import { render } from "./LabelOrderDetailPage.vue?vue&type=template&id=5a99c3be&scoped=true"
import script from "./LabelOrderDetailPage.vue?vue&type=script&lang=js"
export * from "./LabelOrderDetailPage.vue?vue&type=script&lang=js"

import "./LabelOrderDetailPage.vue?vue&type=style&index=0&id=5a99c3be&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src413274616/src/hybrid_inventory_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a99c3be"]])

export default __exports__